'use client';
import DefaultAvatar from '@/assets/icons/defaultAvatar.svg';
import ErrorImg from '@/assets/images/errorImg.png';
import { imageUtil } from '@/utils/imageUtil';
import Image, { ImageProps } from 'next/image';
import { useRef, useState } from 'react';
import loadingImg from '../../assets/images/loadingImg';

interface props {
  src: string; //图片路径
  width: number; //图片生成CDN的宽度
  height: number; //图片生成CDN的高度
  quality?: number; //图片清晰度，默认70
  alt?: string; //图片描述
  errorImgType?: number; //展示兜底图的类型，默认展示商品兜底图; -1：不展示兜底图，直接隐藏图片元素；1: 展示头像的兜底图
  className?: string; //传入样式名
  onError?: Function; //图片加载失败钩子函数;
  onLoad?: Function; //图片加载成功钩子函数;
  style?: any;
  isPlaceholder?: boolean; //loading中是否展示占位图
  shouldKeepOriginal?: boolean; //是否保留原图宽高比
}
interface loaderProps {
  src: string;
  width: number;
  quality?: number;
}

export default function CDNImage(props: ImageProps | props) {
  const {
    src,
    width: originW,
    height: originH,
    alt,
    quality,
    errorImgType,
    className,
    onLoad,
    onError,
    isPlaceholder,
    style,
    shouldKeepOriginal,
    ...rest
  }: any = props;
  const cdnImage = useRef(null);
  const cdnImageLoader = ({ src, width, quality = 70 }: loaderProps) => {
    const height = Math.round((originH / originW) * width);
    if (/^(http|https):\/\/|\/\//.test(src)) {
      return src;
    } else if (shouldKeepOriginal) {
      return imageUtil.concatImgUrlWithoutForceHttps(
        src.trim(),
        undefined,
        undefined,
        quality,
        process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(',')?.filter((v) => v.trim()),
      );
    } else {
      return imageUtil.concatImgUrlWithoutForceHttps(
        src.trim(),
        width,
        height,
        quality,
        process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(',')?.filter((v) => v.trim()),
      );
    }
  };

  const [isError, setIsError] = useState<boolean>(false);

  // 图片加载失败时处理逻辑
  if (!src || isError) {
    return errorImgType === -1 ? null : errorImgType === 1 ? (
      <DefaultAvatar
        className={className}
        style={{ width: originW, height: originH, ...style }}
        {...rest}
      />
    ) : (
      <Image
        src={ErrorImg}
        className={className}
        style={{ width: originW, height: originH, ...style }}
        {...rest}
      />
    );
  }

  return (
    <Image
      className={`${className || ''}`}
      ref={cdnImage}
      style={style}
      loader={cdnImageLoader}
      src={src}
      width={originW}
      height={originH}
      alt={alt || ''}
      placeholder={isPlaceholder ? loadingImg : 'empty'}
      onError={(e) => {
        setIsError(true);
        onError && onError(e);
      }}
      onLoad={() => {
        onLoad && onLoad();
      }}
      {...rest}
    />
  );
}
